import { SessionsAPI } from "../infrastructure/api/sessions.api";

/** What therapist and patient agreed to work on after a session. */

export async function listSessionAgreements(sessionId: string) {
    const { data } = await SessionsAPI.getAgreements(sessionId);
    return data;
}

export async function createSessionAgreement(sessionId: string, text: string) {
    const { data } = await SessionsAPI.createAgreement(sessionId, text);
    return data;
}

export async function updateSessionAgreement(agreementId: string, changes: { text?: string; order?: number }) {
    const { data } = await SessionsAPI.updateAgreement(agreementId, changes);
    return data;
}

export async function deleteSessionAgreement(agreementId: string): Promise<void> {
    await SessionsAPI.deleteAgreement(agreementId);
}

/** Show the drafts to the patient; answers with every agreement as it now stands. */
export async function publishSessionAgreements(sessionId: string) {
    const { data } = await SessionsAPI.publishAgreements(sessionId);
    return data;
}
